const Environment = require('./Environment');
const Logger = require('./Logger');

// Create gtag function for AdWords
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
}

const transactionComplete = (trackingData, cartInfo) => {
  if (Environment.getEnv === 'PRODUCTION') {
    try {
      let couponUsed = 'No coupon used';
      if (cartInfo.coupon && cartInfo.coupon.code) {
        couponUsed = cartInfo.coupon.code;
      }

      const lineItems = [];
      if (cartInfo.subscription && cartInfo.subscription.plan) {
        const subscriptionToAddData = {
          name: `${cartInfo.subscription.plan.title} Subscription`,
          price:
            cartInfo.subscription.plan.costWithCoupon ||
            cartInfo.subscription.plan.actualCost,
          quantity: 1,
          id: cartInfo.subscription.plan._id || '1234',
        };
        lineItems.push(subscriptionToAddData);
      }
      if (cartInfo.productsAndDetails && cartInfo.productsAndDetails.length) {
        cartInfo.productsAndDetails.forEach((productAndDetails) => {
          let productName =
            productAndDetails.product.name || 'Missing product name';
          if (
            productAndDetails.color !== 'NONE' &&
            productAndDetails.variation !== 'NONE'
          ) {
            productName = `${productName} - ${productAndDetails.color}, ${productAndDetails.variation}`;
          } else if (productAndDetails.color !== 'NONE') {
            productName = `${productName} - productAndDetails.color`;
          } else if (productAndDetails.variation !== 'NONE') {
            productName = `${productName} - productAndDetails.variation`;
          }
          const productToAddData = {
            name: productName,
            price:
              productAndDetails.promoItem &&
              productAndDetails.product.ownPromoData
                ? productAndDetails.product.ownPromoData.cost
                : productAndDetails.product.actualCost || 0,
            quantity: productAndDetails.quantity || 1,
            id: productAndDetails.product.sku || 'Missing product SKU',
          };
          lineItems.push(productToAddData);
        });
      }

      gtag(
        'event',
        'purchase',
        {
          transaction_id: trackingData.res.justPurchasedPurchaseId, // eslint-disable-line camelcase
          currency: 'USD',
          value: parseFloat(trackingData.total, 10),
          tax: parseFloat(trackingData.taxesAndFees, 10),
          shipping: parseFloat(trackingData.shipping, 10),
          items: lineItems,
          coupon: couponUsed,
        },
        { send_to: Environment.getGoogleAdWordsIdAndProperty }, // eslint-disable-line camelcase
      );
      gtag('event', 'conversion', {
        send_to: Environment.getGoogleAdWordsIdAndProperty, // eslint-disable-line camelcase
        value: parseFloat(trackingData.total, 10),
        currency: 'USD',
        transaction_id: trackingData.res.justPurchasedPurchaseId, // eslint-disable-line camelcase
      });
    } catch (e) {
      Logger.error(e);
    }
  }
};

module.exports = {
  transactionComplete,
};
